import sportRoutes from '@app/router/routes/sport';
import virtualRoutes from '@app/router/routes/virtuals';
import specialsRoutes from '@app/router/routes/specials';
import searchRoutes from '@app/router/routes/search';
import shopsRoutes from '@app/router/routes/shops';
import resultsRoutes from '@app/router/routes/results';
import accountRoutes from '@app/router/routes/account';
import registerRoutes from '@app/router/routes/register';
import paymentRoutes from '@app/router/routes/payment';
import wikiRoutes from '@app/router/routes/wiki';
import promotionsRoutes from '@app/router/routes/promotions';
import ticketsRoutes from '@app/router/routes/tickets';

export default [
    ...sportRoutes,
    ...virtualRoutes,
    ...specialsRoutes,
    ...searchRoutes,
    ...shopsRoutes,
    ...resultsRoutes,
    ...accountRoutes,
    ...registerRoutes,
    ...paymentRoutes,
    ...wikiRoutes,
    ...promotionsRoutes,
    ...ticketsRoutes,
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/app/router/routes/index.ts